// extracted by mini-css-extract-plugin
module.exports = {"link":"Header_link__3oCXK"};